import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { recortarCadena, descargarFicheroPasandoBase64 } from '../librerias/funciones'

import {
    CloseOutlined, DownloadOutlined

} from '@ant-design/icons';

import { Drawer } from 'antd';

const VisorGenerico = ({ props, configApp }) => {

    return (
        <>

                <Drawer
                    width={configApp.width <= 900 ? '100%' : 800}
                    closable={false}
                    onClose={() => { props.CERRAR_VISOR(false) }}
                    visible={props.ABRIR_VISOR}
                    placement={"right"}
                    bodyStyle={{ padding: '0px', margin: '0px', lineHeight: '0px' }}
                    style={{ color: '#fff' }}>




                    <div className='containerHeaderDrawer'>
                        <div className='itemHeaderDrawer1'>
                            <CloseOutlined onClick={(e) => { props.CERRAR_VISOR(false) }}></CloseOutlined>
                            <div>
                                {Object.keys(props.PROPIEDADES_DOC).length > 0 ?
                                    configApp.width <= 900 ? recortarCadena(props.PROPIEDADES_DOC.TITULO.toUpperCase(), 20, "...") : props.PROPIEDADES_DOC.TITULO.toUpperCase()
                                    :
                                    "VISTA PREVIA"
                                }
                            </div>
                        </div>


                        <div className='itemHeaderDrawer2'>
                            {props.MOSTRAR_BOTON_DESCARGA ?
                                <div  className={`Visor_Telegram_item_2 btnColor`} onClick={() =>{props.EVENTO_DESCARGA(props.PROPIEDADES_DOC.ID)}}>
                                    {"Descargar"}  <DownloadOutlined style={{ fontSize: '25px'}}> </DownloadOutlined>
                                </div>
                                :
                                null
                            }
                        </div>

                    </div>




                    {props.PROPIEDADES_DOC.URL === "" ?
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '75vh', color: '#000' }}> <div color=" mdb-color darken-3" className="spinner-border  fast" role="status" disabled /> </div>
                        :
                        props.PROPIEDADES_DOC.TIPO_DOCUMENTO === "DOC" ?
                            <iframe title='Visor de pdf' src={props.PROPIEDADES_DOC.URL} style={{ width: configApp.width <= 900 ? '100%' : '800px', border: 0 }} className="estiloVisorDoc"></iframe>
:
                            props.PROPIEDADES_DOC.TIPO_DOCUMENTO === "IMG" ?

                            <div className="Container_doc_Visor_Telegram">
                            {props.PROPIEDADES_DOC.URL === "" ?
                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '75vh', color: '#fff' }}> <div color=" mdb-color darken-3" className="spinner-border  fast" role="status" disabled /> </div>
                                :
                                <img src={props.PROPIEDADES_DOC.URL} alt="" ></img>
                            }
                        </div>
                            :
                            <div className='continaerVideo'>
                                <video width={configApp.width <= 900 ? '100%' : 800} controls>
                                    <source src={props.PROPIEDADES_DOC.URL} />
                                </video>
                            </div>
                    }
                </Drawer>
            
        </>
    )
}


VisorGenerico.propTypes = {
    title: PropTypes.string,
    ABRIR_VISOR: PropTypes.bool,
    CERRAR_VISOR: PropTypes.func,

    PROPIEDADES_DOC: PropTypes.object,
    ZOOM_DOCUMENTO: PropTypes.bool,
    MOSTRAR_BOTON_DESCARGA: PropTypes.bool,
    EVENTO_DESCARGA:PropTypes.func
};

const mapStateToProps = (state, props) => {
    return {
        props: props,
        configApp: state.configApp,
    };
}

export default connect(mapStateToProps)(VisorGenerico);